module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fBwx5"))).then(() => parcelRequire('dJXJK'));